import { useContext } from 'react';
import ModeContext from '../context/modeTypeContext';

/**
 * useModeTypeContext is a convenience hook to access the mode context
 */
export default function useModeTypeContext() {
  return useContext(ModeContext);
}
